import baseRoute from '../baseRoute';

export default `${baseRoute}/jobMaterial` as const;
